<template>
  <div class="detail-container">
    <el-card class="admin-list-card" shadow="never">
      <template #header>
        <div class="header-container">
          <el-button type="text" @click="handleBack">
            <i class="el-icon-arrow-left"></i> 返回
          </el-button>
          <span>{{ promoter }} 的推广详情</span>
          <!-- 新增：状态筛选器 -->
          <el-select v-model="currentFilter" placeholder="请选择状态" style="width: 160px; margin-left: auto"
            @change="handleFilterChange">
            <el-option label="全部" value="all"></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
            <el-option label="待结算" value="2"></el-option>
          </el-select>
        </div>
      </template>

      <!-- 表格：绑定筛选后的数据 -->
      <el-table :data="filteredTableData" style="width: 100%">
        <el-table-column prop="phone" label="邀请用户" />
        <el-table-column prop="lcode" label="邀请码" />
        <el-table-column prop="money" label="用户充值" />
        <el-table-column prop="ratiomoney" label="奖励金额" />
        <el-table-column prop="settle" label="是否结算">
          <template #default="{ row }">
            <!-- 三种状态对应不同颜色的tag -->
            <el-tag :type="row.state === '已结算' ? 'success' :
                row.state === '待结算' ? 'warning' : 'danger'
              ">
              {{ row.state }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdate" label="充值时间" />
      </el-table>

      <!-- 新增：三种状态总额展示 -->
      <div style="margin-top: 20px; text-align: right">
        <span style="font-weight: bold; margin-right: 15px">
          未结金额：<span style="color: #f56c6c">{{ unsettledTotal }}元</span>
        </span>
        <span style="font-weight: bold; margin-right: 15px">
          已结金额：<span style="color: #67c23a">{{ settledTotal }}元</span>
        </span>
        <span style="font-weight: bold">
          待结金额：<span style="color: #e6a23c">{{ pendingTotal }}元</span>
        </span>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import store from "../../store/index";
import axios from "axios";

const router = useRouter();
const route = useRoute();

const promoter = ref("");
promoter.value = store.state.userphone.username;

// 原始数据 + 筛选后的数据（分离避免污染原始数据）
const tableData = ref([]);
const filteredTableData = ref([]);

// 状态筛选相关：默认显示全部
const currentFilter = ref("all");
// 状态映射（0=未结算、1=已结算、2=待结算）
const stateMap = { 0: "未结算", 1: "已结算", 2: "待结算" };

// 三种状态总额（初始值0.00）
const unsettledTotal = ref("0.00"); // 未结算（0）
const settledTotal = ref("0.00"); // 已结算（1）
const pendingTotal = ref("0.00"); // 待结算（2）

// 筛选逻辑：根据当前选择的状态过滤数据
const handleFilterChange = () => {
  switch (currentFilter.value) {
    case "all":
      filteredTableData.value = [...tableData.value];
      break;
    case "0": // 未结算
      filteredTableData.value = tableData.value.filter(
        (item) => item.rawState === 0
      );
      break;
    case "1": // 已结算
      filteredTableData.value = tableData.value.filter(
        (item) => item.rawState === 1
      );
      break;
    case "2": // 待结算
      filteredTableData.value = tableData.value.filter(
        (item) => item.rawState === 2
      );
      break;
  }
};

onMounted(async () => {
  const phone = store.state.userphone.phone;
  try {
    const res = await axios.get(`/admin/getMacInfoAadmin?phone=${phone}`);
    console.log("res", res);

    if (res.data.msg === "success" && Array.isArray(res.data.data)) {
      // 处理原始数据：
      // 1. 保留原始数字状态（rawState）用于筛选
      // 2. 映射状态文字（state）
      // 3. 格式化时间、金额、手机号
      tableData.value = res.data.data.map((item) => ({
        ...item,
        rawState: item.state, // 保留原始数字状态（0/1/2）
        state: stateMap[item.state] || "未知状态", // 映射为文字状态
        money: `${parseFloat(item.money || 0).toFixed(2)}元`, // 充值金额格式化
        ratiomoney: `${parseFloat(item.ratiomoney || 0).toFixed(2)}元`, // 奖励金额格式化
        phone: item.userphone
          ? item.userphone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
          : "未知手机号",
        createdate: new Date(item.createdate).toLocaleString(), // 统一格式化充值时间（修正原Creationtime笔误）
      }));

      // 计算三种状态的总额（基于原始数字状态筛选，避免文字匹配错误）
      calculateTotals(res.data.data);

      // 初始化筛选：默认显示全部数据
      handleFilterChange();
    }
  } catch (error) {
    console.error("获取推广详情失败", error);
    tableData.value = [];
    filteredTableData.value = [];
  }
  console.log("达人列表", tableData.value);
});

// 计算各状态总额（独立函数，逻辑清晰）
const calculateTotals = (originData) => {
  // 未结算总额（状态0）
  unsettledTotal.value = originData
    .filter((item) => item.state === 0)
    .reduce((sum, item) => sum + parseFloat(item.ratiomoney || 0), 0)
    .toFixed(2);

  // 已结算总额（状态1）
  settledTotal.value = originData
    .filter((item) => item.state === 1)
    .reduce((sum, item) => sum + parseFloat(item.ratiomoney || 0), 0)
    .toFixed(2);

  // 待结算总额（状态2）
  pendingTotal.value = originData
    .filter((item) => item.state === 2)
    .reduce((sum, item) => sum + parseFloat(item.ratiomoney || 0), 0)
    .toFixed(2);
};

const handleBack = () => {
  router.go(-1);
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
}

/* 头部布局：返回按钮 + 标题 + 筛选器 横向排列 */
.header-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.el-card__header span {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
}

/* 调整筛选器样式，与头部对齐 */
.el-select {
  margin-left: auto !important;
}

/* 优化tag显示效果 */
.el-tag {
  padding: 4px 8px;
  font-size: 12px;
}
</style>
